// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { completeStudentOnboarding, createTutorCertification, createTutorEducation, createUserInterest, deleteTutorCertification, deleteTutorEducation, deleteUserInterest, fetchActivePlans, fetchCourses, fetchHolidays, fetchLevels, getLectureById, getTutorCertifications, getTutorEducations, getUserInterests, loginWithGoogle, logout, logoutAll, type Options, refreshToken, saveOnboardingProgress, updateTutorCertification, updateTutorEducation } from '../sdk.gen';
import type { CompleteStudentOnboardingData, CompleteStudentOnboardingError, CompleteStudentOnboardingResponse, CreateTutorCertificationData, CreateTutorCertificationError, CreateTutorCertificationResponse, CreateTutorEducationData, CreateTutorEducationError, CreateTutorEducationResponse, CreateUserInterestData, CreateUserInterestError, CreateUserInterestResponse, DeleteTutorCertificationData, DeleteTutorCertificationError, DeleteTutorCertificationResponse, DeleteTutorEducationData, DeleteTutorEducationError, DeleteTutorEducationResponse, DeleteUserInterestData, DeleteUserInterestError, DeleteUserInterestResponse, FetchActivePlansData, FetchActivePlansResponse, FetchCoursesData, FetchCoursesError, FetchCoursesResponse, FetchHolidaysData, FetchHolidaysResponse, FetchLevelsData, FetchLevelsResponse, GetLectureByIdData, GetLectureByIdError, GetLectureByIdResponse, GetTutorCertificationsData, GetTutorCertificationsError, GetTutorCertificationsResponse, GetTutorEducationsData, GetTutorEducationsError, GetTutorEducationsResponse, GetUserInterestsData, GetUserInterestsError, GetUserInterestsResponse, LoginWithGoogleData, LoginWithGoogleError, LoginWithGoogleResponse, LogoutAllData, LogoutAllError, LogoutAllResponse, LogoutData, LogoutResponse, RefreshTokenData, RefreshTokenError, RefreshTokenResponse, SaveOnboardingProgressData, SaveOnboardingProgressError, SaveOnboardingProgressResponse, UpdateTutorCertificationData, UpdateTutorCertificationError, UpdateTutorCertificationResponse, UpdateTutorEducationData, UpdateTutorEducationError, UpdateTutorEducationResponse } from '../types.gen';

/**
 * logout
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * logout_all
 */
export const logoutAllMutation = (options?: Partial<Options<LogoutAllData>>): UseMutationOptions<LogoutAllResponse, LogoutAllError, Options<LogoutAllData>> => {
    const mutationOptions: UseMutationOptions<LogoutAllResponse, LogoutAllError, Options<LogoutAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logoutAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * refresh
 */
export const refreshTokenMutation = (options?: Partial<Options<RefreshTokenData>>): UseMutationOptions<RefreshTokenResponse, RefreshTokenError, Options<RefreshTokenData>> => {
    const mutationOptions: UseMutationOptions<RefreshTokenResponse, RefreshTokenError, Options<RefreshTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Authenticate with Google OAuth
 */
export const loginWithGoogleMutation = (options?: Partial<Options<LoginWithGoogleData>>): UseMutationOptions<LoginWithGoogleResponse, LoginWithGoogleError, Options<LoginWithGoogleData>> => {
    const mutationOptions: UseMutationOptions<LoginWithGoogleResponse, LoginWithGoogleError, Options<LoginWithGoogleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWithGoogle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const fetchCoursesQueryKey = (options?: Options<FetchCoursesData>) => createQueryKey('fetchCourses', options);

/**
 * Fetch all active courses
 */
export const fetchCoursesOptions = (options?: Options<FetchCoursesData>) => queryOptions<FetchCoursesResponse, FetchCoursesError, FetchCoursesResponse, ReturnType<typeof fetchCoursesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fetchCourses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fetchCoursesQueryKey(options)
});

export const getLectureByIdQueryKey = (options: Options<GetLectureByIdData>) => createQueryKey('getLectureById', options);

/**
 * Fetch a single lecture by ID
 */
export const getLectureByIdOptions = (options: Options<GetLectureByIdData>) => queryOptions<GetLectureByIdResponse, GetLectureByIdError, GetLectureByIdResponse, ReturnType<typeof getLectureByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLectureById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLectureByIdQueryKey(options)
});

export const fetchActivePlansQueryKey = (options?: Options<FetchActivePlansData>) => createQueryKey('fetchActivePlans', options);

/**
 * Fetch active subscription plans
 */
export const fetchActivePlansOptions = (options?: Options<FetchActivePlansData>) => queryOptions<FetchActivePlansResponse, DefaultError, FetchActivePlansResponse, ReturnType<typeof fetchActivePlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fetchActivePlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fetchActivePlansQueryKey(options)
});

export const fetchLevelsQueryKey = (options?: Options<FetchLevelsData>) => createQueryKey('fetchLevels', options);

/**
 * Fetch all proficiency levels
 */
export const fetchLevelsOptions = (options?: Options<FetchLevelsData>) => queryOptions<FetchLevelsResponse, DefaultError, FetchLevelsResponse, ReturnType<typeof fetchLevelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fetchLevels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fetchLevelsQueryKey(options)
});

export const fetchHolidaysQueryKey = (options?: Options<FetchHolidaysData>) => createQueryKey('fetchHolidays', options);

/**
 * Fetch upcoming holidays
 */
export const fetchHolidaysOptions = (options?: Options<FetchHolidaysData>) => queryOptions<FetchHolidaysResponse, DefaultError, FetchHolidaysResponse, ReturnType<typeof fetchHolidaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fetchHolidays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fetchHolidaysQueryKey(options)
});

export const getTutorEducationsQueryKey = (options: Options<GetTutorEducationsData>) => createQueryKey('getTutorEducations', options);

/**
 * Fetch tutor's education history
 */
export const getTutorEducationsOptions = (options: Options<GetTutorEducationsData>) => queryOptions<GetTutorEducationsResponse, GetTutorEducationsError, GetTutorEducationsResponse, ReturnType<typeof getTutorEducationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTutorEducations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTutorEducationsQueryKey(options)
});

/**
 * Create a new education entry
 */
export const createTutorEducationMutation = (options?: Partial<Options<CreateTutorEducationData>>): UseMutationOptions<CreateTutorEducationResponse, CreateTutorEducationError, Options<CreateTutorEducationData>> => {
    const mutationOptions: UseMutationOptions<CreateTutorEducationResponse, CreateTutorEducationError, Options<CreateTutorEducationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTutorEducation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an education entry
 */
export const deleteTutorEducationMutation = (options?: Partial<Options<DeleteTutorEducationData>>): UseMutationOptions<DeleteTutorEducationResponse, DeleteTutorEducationError, Options<DeleteTutorEducationData>> => {
    const mutationOptions: UseMutationOptions<DeleteTutorEducationResponse, DeleteTutorEducationError, Options<DeleteTutorEducationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTutorEducation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an education entry
 */
export const updateTutorEducationMutation = (options?: Partial<Options<UpdateTutorEducationData>>): UseMutationOptions<UpdateTutorEducationResponse, UpdateTutorEducationError, Options<UpdateTutorEducationData>> => {
    const mutationOptions: UseMutationOptions<UpdateTutorEducationResponse, UpdateTutorEducationError, Options<UpdateTutorEducationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTutorEducation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTutorCertificationsQueryKey = (options: Options<GetTutorCertificationsData>) => createQueryKey('getTutorCertifications', options);

/**
 * Fetch tutor's certifications
 */
export const getTutorCertificationsOptions = (options: Options<GetTutorCertificationsData>) => queryOptions<GetTutorCertificationsResponse, GetTutorCertificationsError, GetTutorCertificationsResponse, ReturnType<typeof getTutorCertificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTutorCertifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTutorCertificationsQueryKey(options)
});

/**
 * Create a new certification entry
 */
export const createTutorCertificationMutation = (options?: Partial<Options<CreateTutorCertificationData>>): UseMutationOptions<CreateTutorCertificationResponse, CreateTutorCertificationError, Options<CreateTutorCertificationData>> => {
    const mutationOptions: UseMutationOptions<CreateTutorCertificationResponse, CreateTutorCertificationError, Options<CreateTutorCertificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTutorCertification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a certification entry
 */
export const deleteTutorCertificationMutation = (options?: Partial<Options<DeleteTutorCertificationData>>): UseMutationOptions<DeleteTutorCertificationResponse, DeleteTutorCertificationError, Options<DeleteTutorCertificationData>> => {
    const mutationOptions: UseMutationOptions<DeleteTutorCertificationResponse, DeleteTutorCertificationError, Options<DeleteTutorCertificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTutorCertification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a certification entry
 */
export const updateTutorCertificationMutation = (options?: Partial<Options<UpdateTutorCertificationData>>): UseMutationOptions<UpdateTutorCertificationResponse, UpdateTutorCertificationError, Options<UpdateTutorCertificationData>> => {
    const mutationOptions: UseMutationOptions<UpdateTutorCertificationResponse, UpdateTutorCertificationError, Options<UpdateTutorCertificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTutorCertification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserInterestsQueryKey = (options: Options<GetUserInterestsData>) => createQueryKey('getUserInterests', options);

/**
 * Fetch user's interests
 */
export const getUserInterestsOptions = (options: Options<GetUserInterestsData>) => queryOptions<GetUserInterestsResponse, GetUserInterestsError, GetUserInterestsResponse, ReturnType<typeof getUserInterestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInterests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInterestsQueryKey(options)
});

/**
 * Remove an interest from user's profile
 */
export const deleteUserInterestMutation = (options?: Partial<Options<DeleteUserInterestData>>): UseMutationOptions<DeleteUserInterestResponse, DeleteUserInterestError, Options<DeleteUserInterestData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserInterestResponse, DeleteUserInterestError, Options<DeleteUserInterestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserInterest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add an interest to user's profile
 */
export const createUserInterestMutation = (options?: Partial<Options<CreateUserInterestData>>): UseMutationOptions<CreateUserInterestResponse, CreateUserInterestError, Options<CreateUserInterestData>> => {
    const mutationOptions: UseMutationOptions<CreateUserInterestResponse, CreateUserInterestError, Options<CreateUserInterestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUserInterest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete student onboarding
 */
export const completeStudentOnboardingMutation = (options?: Partial<Options<CompleteStudentOnboardingData>>): UseMutationOptions<CompleteStudentOnboardingResponse, CompleteStudentOnboardingError, Options<CompleteStudentOnboardingData>> => {
    const mutationOptions: UseMutationOptions<CompleteStudentOnboardingResponse, CompleteStudentOnboardingError, Options<CompleteStudentOnboardingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeStudentOnboarding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save partial onboarding progress
 *
 * Saves the current step progress so users can resume later
 */
export const saveOnboardingProgressMutation = (options?: Partial<Options<SaveOnboardingProgressData>>): UseMutationOptions<SaveOnboardingProgressResponse, SaveOnboardingProgressError, Options<SaveOnboardingProgressData>> => {
    const mutationOptions: UseMutationOptions<SaveOnboardingProgressResponse, SaveOnboardingProgressError, Options<SaveOnboardingProgressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveOnboardingProgress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
